// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2JZHA","header":"MessagesList_header__10Avi","chat":"MessagesList_chat__3lp5N"};